import { gql } from '@apollo/client'

export const OPERATION_EXPORT_STANDARD = gql`
  query exportCouponsStandard(
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $availability: String
    $sort_by: String
    $sort_direction: String
    $sf_ids: [String]
  ) {
    base64: exportCouponsStandard(
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      availability: $availability
      sort_by: $sort_by
      sort_direction: $sort_direction
      sf_ids: $sf_ids
    )
  }
`

export const OPERATION_EXPORT_H3 = gql`
  query exportCouponsStandard(
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $availability: String
    $sort_by: String
    $sort_direction: String
    $sf_ids: [String]
  ) {
    base64: exportCouponsH3(
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      availability: $availability
      sort_by: $sort_by
      sort_direction: $sort_direction
      sf_ids: $sf_ids
    )
  }
`

const OPERATION_FIND_COUPONS_STANDARD = gql`
  query findCoupons(
    $offset: Int
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $usage_date_start: String
    $usage_date_end: String
    $availability: String
    $sort_by: String
    $sort_direction: String
    $sf_ids: [String]
    $langue: String
  ) {
    coupons: searchCoupons(
      type: "wifirstsite"
      offset: $offset
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      usage_date_start: $usage_date_start
      usage_date_end: $usage_date_end
      availability: $availability
      sort_by: $sort_by
      sort_direction: $sort_direction
      sf_ids: $sf_ids
      langue: $langue
    ) {
      id
      site {
        name
      }
      code
      number_of_devices
      offer {
        name
      }
      used
      valid
      type
      description
      first_provisioning_date
      created_by
      creator_firstname
      creator_lastname
      created_at
      validity_period
      phone
      starts_at
      ends_at
      expired
      disabled
      available_soon
      available
      correlation_id
    }
  }
`

export const OPERATION_FIND_COUPONS_H3 = gql`
  query findCoupons(
    $offset: Int
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $availability: String
    $sf_ids: [String]
    $sort_by: String
    $sort_direction: String
  ) {
    coupons: searchCoupons(
      type: "h3"
      offset: $offset
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      availability: $availability
      sf_ids: $sf_ids
      sort_by: $sort_by
      sort_direction: $sort_direction
    ) {
      ... on Coupon {
        id
        used
        valid
        site {
          name
        }
        code
        location
        firstname
        lastname
        phone
        created_at
        resident
      }
    }
  }
`

export const OPERATION_FIND_COUPON_STANDARD = gql`
  query findCoupon($id: Int!, $langue: String) {
    coupon: findCoupon(id: $id, type: "wifirstsite", langue: $langue) {
      ... on Coupon {
        id
        site {
          name
        }
        code
        number_of_devices
        offer {
          name
        }
        used
        valid
        first_provisioning_date
        created_by
        creator_firstname
        creator_lastname
        created_at
        validity_period
        phone
        starts_at
        ends_at
        description
        expired
        disabled
        available_soon
        available
        correlation_id
        hotline_number
        with_ran_access
      }
    }
  }
`

export const OPERATION_FIND_COUPON_H3 = gql`
  query findCoupon($id: Int!) {
    coupon: findCoupon(id: $id, type: "h3") {
      ... on Coupon {
        id
        used
        valid
        site {
          name
        }
        code
        location
        firstname
        lastname
        phone
        created_at
      }
    }
  }
`

export const OPERATION_FIND_COUPONS_AGGS_STANDARD = gql`
  query findCouponsAggs($verbatim: String, $created_at_start: String, $created_at_end: String, $sf_ids: [String]) {
    aggs: findCouponsAggs(
      type: "wifirstsite"
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      sf_ids: $sf_ids
    ) {
      key
      count
      percentage
    }
  }
`

export const OPERATION_FIND_COUPONS_AGGS_H3 = gql`
  query findCouponsAggs(
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $availability: String
    $sf_ids: [String]
  ) {
    aggs: findCouponsAggs(
      type: "h3"
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      availability: $availability
      sf_ids: $sf_ids
    ) {
      key
      count
      percentage
    }
  }
`

export const OPERATION_FIND_OFFERS = gql`
  query findOffers($sf_id: String!) {
    offers: findSiteOffers(sf_id: $sf_id) {
      ... on Offer {
        id
        name
        max_usage
        duration_unit
        duration_value
        duration_limit_month
        price
        currency
        hardlimit
      }
    }
  }
`

export const OPERATION_FIND_BY_CORRELATION = gql`
  query FindCouponByCorrelationId($findCouponByCorrelationIdId: ID!, $langue: String) {
    findCouponByCorrelationId(id: $findCouponByCorrelationIdId, langue: $langue) {
      id
      code
      offer {
        name
      }
      site {
        name
      }
      used
      valid
      starts_at
      ends_at
      number_of_devices
      available_soon
      available
      hotline_number
    }
  }
`

export default OPERATION_FIND_COUPONS_STANDARD
